export default __webpack_public_path__ + "static/media/Vicious Hound Boots.ef11be89.jpg";